// 负责广告脚本加载和初始化
// 处理广告元素的可视区域检测(Intersection Observer)
// 管理广告加载重试机制
export default {
	data() {
		return {
			adObserver: null,
			observedAds: new Set(),
			adLoadRetries: new Map(),
			maxRetries: 3,
		}
	},

	mounted() {
		this.initAdSystem()
	},

	beforeDestroy() {
		this.cleanupAdSystem()
	},

	methods: {
		async initAdSystem() {
			if (typeof window !== 'undefined') {
				await this.loadAdSenseScript()
				this.setupAdObserver()
			}
		},

		async loadAdSenseScript() {
			if (window.adsbygoogle?.loaded) {
				this.$eventrack('adscript_loaded', 'expose')
				return
			}

			if (!this.adsensConfig?.scriptUrl) {
				this.$eventrack('no_adscript_config', 'expose')
				return
			}

			try {
				await this.loadScript(this.adsensConfig.scriptUrl)
				this.$eventrack('adscript_add_success', 'expose')
			} catch (error) {
				console.error('Failed to load AdSense script:', error)
				this.$eventrack('adscript_load_error', 'error')
			}
		},

		loadScript(url) {
			return new Promise((resolve, reject) => {
				const script = document.createElement('script')
				script.src = url
				script.async = true
				script.crossOrigin = 'anonymous'
				script.onload = resolve
				script.onerror = reject
				document.head.appendChild(script)
			})
		},

		setupAdObserver() {
			this.adObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach(this.handleAdIntersection)
				},
				{
					threshold: 0.1,
				},
			)
		},

		handleAdIntersection(entry) {
			if (entry.isIntersecting) {
				const adElement = entry.target
				this.adObserver.unobserve(adElement)
				this.loadAd(adElement)
			}
		},

		async loadAd(adElement, retryCount = 0) {
			if (!window.adsbygoogle?.loaded) {
				if (retryCount < this.maxRetries) {
					setTimeout(() => {
						this.loadAd(adElement, retryCount + 1)
					}, 1000)
					return
				}
				// 静默失败,只记录统计
				this.$eventrack?.('ad_script_load_failed', 'error', {
					retries: retryCount,
				})
				return
			}

			try {
				await this.$nextTick()
				if (adElement.offsetWidth > 0) {
					;(window.adsbygoogle = window.adsbygoogle || []).push({})
				}
			} catch (error) {
				// 静默处理错误,记录统计
				this.$eventrack?.('ad_push_error', 'error', {
					error: error.message,
				})
			}
		},

		cleanupAdSystem() {
			if (this.adObserver) {
				this.adObserver.disconnect()
				this.adObserver = null
			}
			this.observedAds?.clear()
		},
	},
}
